import { Box, Flex, Grid, GridItem, Image, Input, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, useDisclosure, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, FormControl, FormLabel, Button, Center, Spinner, } from '@chakra-ui/react'
import MyDiv from './employeeStatus.style';
import {CustomButton, CustomToast,ActionEditIcon, CustomTable } from '../../../../components';
import { useEffect, useState } from 'react';
import PlusIcon from "../../../../assets/images/Vector.svg";
import { useFetch } from '../../../../hooks/useFetch';
import { IEmployeeStatus } from './model';
import { Column } from "../../../../components/CustomTable/customTable";

const Header = [
    { id: 1, head: 'S. No' },
    { id: 2, head: 'Status Name' },
    { id: 3, head: 'Actions' },
];

const EmployeeStatus = () => {
    const [employees, setEmployees] = useState<IEmployeeStatus[]>([]);
    const [DrawerOpen, setDrawerOpen] = useState(false);
    const [selectedId, setSelectedId] = useState<number | null>(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [currentEmployeeStatus, setCurrentEmployeeStatus] = useState({ id: 0, statusName: '' });
    const { addToast } = CustomToast();
    const { fetchApi, loading } = useFetch(addToast);
    
    useEffect(() => {
        loadEmployee();
    }, []);
        
    const loadEmployee = async () => {
        const response = await fetchApi<IEmployeeStatus[]>("Hrlense_EmployeeStatus", "GET");
        console.log('response',response)
            if (response) setEmployees(response);
    };
    
    const handleAddNewEmployeeStatus = () => {
        setIsEditMode(false);
        setCurrentEmployeeStatus({ id: 0, statusName: '' });
        setDrawerOpen(true);
    };

    const handleEditEmployeeStatus = (employeeStatus: IEmployeeStatus) => {
        setIsEditMode(true);
        setSelectedId(employeeStatus.id);
        setCurrentEmployeeStatus(employeeStatus);
        setDrawerOpen(true);
    };

    const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    if (!/^[A-Za-z\s]*$/.test(value)) {
      return;
    }
    setCurrentEmployeeStatus(prev => ({
      ...prev,
      [name]: value
    }));
  };


    const handleSubmit = async () => {
         if (!currentEmployeeStatus.statusName.trim()) {
    addToast({ message: "Please enter Employee Status", status: "warning" });
    return;
  }

        if (isEditMode) {
                const response = await fetchApi(`Hrlense_EmployeeStatus/${currentEmployeeStatus.id}`,"PUT", { id: currentEmployeeStatus.id, statusName: currentEmployeeStatus.statusName,}, null, "Employee Status updated successfully");
          
                if (response) setEmployees((prev) => prev.map((statusName) => (statusName.id === selectedId ? currentEmployeeStatus : statusName)));
        } else {
                const response = await fetchApi<IEmployeeStatus>( "Hrlense_EmployeeStatus", "POST",{ statusName: currentEmployeeStatus.statusName,}, null, "Employee Status added successfully");
                if (response) setEmployees((prev) => [...prev, response]);
        }
              setDrawerOpen(false);
        };


    return (
        <MyDiv>
          <Box position="relative" minH="300px">
            {loading ? (
                <Center position="absolute" top={0} left={0} right={0} bottom={0}>
                <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" />
                </Center>) : (
            <>
            <Flex className="page_heading flex_header" >
                <Text className="font-poppins text_semibold text_3xl">Status List </Text>
                <Flex gap={2}>
                    <CustomButton title="Add New Status" className=' btn font-poppins text_sm text_medium' rightIcon={<Image src={PlusIcon} className='logo' />} onClick={handleAddNewEmployeeStatus} />
                </Flex>
            </Flex>
            <Grid className='grid_container'>
                <GridItem colSpan={12}>
                    <CustomTable value={employees} >
                      <Column header="S. No" body={(_, index) => index + 1} />
                      <Column header="Status Name" field="statusName" />
                      <Column
                        header="Actions"
                        body={(row: any) => (<ActionEditIcon onClick={() => handleEditEmployeeStatus(row)} />
                        )}
                      />
                    </CustomTable>

                </GridItem>
            </Grid>

            <Drawer isOpen={DrawerOpen} placement="right" onClose={() => setDrawerOpen(false)} size="sm">
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerCloseButton />
                    <DrawerHeader borderBottomWidth="1px">{isEditMode ? 'Edit Status' : 'Add New Status'}</DrawerHeader>
                    <DrawerBody display="flex" flexDirection="column" justifyContent="space-between" height="100%">
                        <Box py={4}>
                            <FormControl mb={4} isRequired>
                                <FormLabel>Status Name</FormLabel>
                                <Input name="statusName" value={currentEmployeeStatus.statusName} onChange={handleInputChange} placeholder="Enter status name" />
                            </FormControl>
                        </Box>
                        <Flex justify="flex-end" mt={4} gap={2}>
                            <Button className="font-poppins text_sm text_medium" onClick={() => setDrawerOpen(false)} style={{ backgroundColor: '#D92F34', color: 'white' }}>Cancel</Button>
                            <Button onClick={handleSubmit} className="font-poppins text_sm text_medium" style={{ backgroundColor: '#006838', color: 'white' }}>{isEditMode ? "Update Status Name" : "Add Status Name"}</Button>
                        </Flex>
                    </DrawerBody>
                </DrawerContent>
            </Drawer>
            </>)}
        </Box>
        </MyDiv>
    )
}

export default EmployeeStatus;
